<div [hidden]="!featureLoaded">
  <div class="wizard-header row">
    <div class="col-12 page-title">
      {{ "requests.wizard.title" | translate }}
    </div>

    <ng-container *ngIf="currentWizardStep !== wizardStepsEnum.Request_Preview">
        <div class="col-12">
            <div class="row">
                <div *ngIf="documentRequestHeader?.contractName" class="col-lg-6 text-center text-lg-start summary">
                    <span class="wizard-label">
                      {{ "requests.wizard.contract" | translate }}:
                    </span>
                    <span class="contract-number">
                        {{ documentRequestHeader?.contractName }}
                    </span>
                </div>
                <div class="col-lg-6 text-center text-lg-end summary"
                    *ngIf="showDelegate()">
                    {{ "requests.wizard.summary.selectedDelegate" | translate }}
                    <span class="delegate-name">
                        {{ selectedDelegate?.firstName + " " + selectedDelegate?.lastName }}
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12 subtitle-label">
            <div class="row">
                <div *ngIf="documentRequestHeader?.assetName" class="col-lg-6 text-center text-lg-start summary">
                  <span class="wizard-label">
                    {{ "requests.wizard.asset" | translate }}
                  </span>
                  <span class="asset">
                    {{ documentRequestHeader?.assetName }}
                    <span *ngIf="documentRequestHeader?.assetNumber || documentRequestHeader?.assetUid">,&nbsp;</span>
                  </span>
                  <span *ngIf="documentRequestHeader?.assetNumber" class="text-primary fw-bold">
                    {{ documentRequestHeader?.assetNumber }}
                    <span *ngIf="documentRequestHeader?.assetUid">,&nbsp;</span>
                  </span>
                  <span *ngIf="documentRequestHeader?.assetUid" class="text-primary fw-bold">
                    {{ documentRequestHeader?.assetUid }}
                  </span>
                </div>
                <div *ngIf="showOptionalInsurances()" 
                  class="col-lg-6 text-center text-lg-end summary"
                >
                  {{ "requests.wizard.summary.selectedInsurances" | translate }}
                  <span *ngIf="this.thirdQuestionFormGroup?.value?.answear1" class="insurance">
                    {{ "requests.wizard.answears.GreenCardInsurance" | translate }}
                  </span>
                </div>
            </div>
        </div>
    </ng-container>
  </div>

  <div class="wizard-container">
    <button *ngIf="currentWizardStep !== wizardStepsEnum.Asset_RequestSent"
      class="btn link-btn btn-back-txt" (click)="previousStepHandler(currentWizardStep)"
    >
      <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
      <span>
        {{
          currentWizardStep === wizardStepsEnum.Asset_RequestType || 
          currentWizardStep === wizardStepsEnum.Asset_ChooseContractAndAsset
            ? ("requests.wizard.navAssetsRequestList" | translate)
            : ("requests.wizard.backBtnLabel" | translate)
        }}
      </span>
    </button>

    <div class="wizard-main-content" [ngSwitch]="currentWizardStep">
      <!-- Step entry from request-list - new request -->
      <ng-container
        *ngSwitchCase="wizardStepsEnum.Asset_ChooseContractAndAsset"
      >
        <div class="row">
          <div class="col-12 wizard-question">
            {{ "requests.wizard.questions.SelectContractAndAsset" | translate }}
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
            <label class="label-input required">
              {{ "requests.wizard.contractLabel" | translate }}
            </label>
            <div HJSuppress *ngIf="contractsDataSource.length === 1" class="single-contract fw-semibold mt-3 mb-4">
              {{ contractsDataSource[0].number }}
            </div>
            <div *ngIf="contractsDataSource.length > 1" class="input-dropdown-container">
              <kendo-combobox HJSuppress
                class="custom-kendo-control-xl"
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                [size]="sizeLarge"
                name="contractId"
                [placeholder]="
                  'requests.wizard.placeholder.selectContract' | translate
                "
                [clearButton]="false"
                [data]="filteredContracts"
                [textField]="'number'"
                [valueField]="'contractId'"
                [valuePrimitive]="true"
                [(ngModel)]="contractDetails.contractExternalEntityId"
                (ngModelChange)="contractSelectedHandler($event)"
                #contractExternalEntityId
                (click)="
                  !contractExternalEntityId.isOpen
                    ? contractExternalEntityId.toggle()
                    : null
                "
                [popupSettings]="{popupClass : 'data-hj-suppress'}"
                [filterable]="true"
                (filterChange)="handleFilterContracts($event)"
              >
              </kendo-combobox>
            </div>
          </div>
        </div>
        <div *ngIf="assetsDataSource.length > 0" class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
            <label class="label-input required">
              {{ "requests.wizard.assetLabel" | translate }}
            </label>
            
            <div HJSuppress *ngIf="assetsDataSource.length === 1" class="single-asset fw-semibold mt-3 mb-4">
              {{ assetsDataSource[0].name }}
            </div>
            <div *ngIf="assetsDataSource.length > 1" class="input-dropdown-container">
              <kendo-combobox HJSuppress
                class="custom-kendo-control-xl"
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                [size]="sizeLarge"
                name="assetId"
                [placeholder]="
                  'requests.wizard.placeholder.selectAsset' | translate
                "
                [clearButton]="false"
                [data]="assetsDataSource"
                [textField]="'name'"
                [valueField]="'assetId'"
                [valuePrimitive]="true"
                [(ngModel)]="contractDetails.contractItemExternalEntityId"
                (ngModelChange)="assetSelectedHandler($event)"
                [disabled]="!contractDetails.contractExternalEntityId"
                #contractItemExternalEntityId
                (click)="
                  toggleComboboxAsset(!contractDetails.contractExternalEntityId)
                "
                [popupSettings]="{popupClass : 'data-hj-suppress'}"
              >
                <ng-template kendoComboBoxItemTemplate let-dataItem>
                  <div HJSuppress class="list-item d-flex flex-wrap align-items-center">
                    <span>
                      {{ dataItem?.name }}
                      <span *ngIf="dataItem?.number || dataItem?.uid">,&nbsp;</span>
                    </span>
                    <span *ngIf="dataItem?.number">
                      {{ dataItem?.number }}
                      <span *ngIf="dataItem?.uid">,&nbsp;</span>
                    </span>
                    <span *ngIf="dataItem?.uid">{{ dataItem?.uid }}</span>
                  </div>
                </ng-template>
              </kendo-combobox>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 required-fields-label"
            [innerHTML] ="'common.requiredFields' | translate">
          </div>
        </div>
        <div class="row justify-content-center">
          <div *ngIf="assetErrorMessageTranslateKey" class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
            <ng-container *ngTemplateOutlet="errorMessageTemplate; context: { $implicit: assetErrorMessageTranslateKey}"></ng-container>
          </div>
        </div>
        <div class="row">
          <div class="col-12 action">
            <div class="d-flex justify-content-center mt-5">
              <button
                class="btn primary-btn"
                [disabled]="!wizardEntryCompleted"
                (click)="
                  nextStepHandler(wizardStepsEnum.Asset_ChooseContractAndAsset)
                "
              >
                {{ "requests.wizard.continueBtn" | translate }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- Step entry from request-list - new request -->
      <form #wizardForm="ngForm">
        <!-- Step 0 - WhatTypeOfRequestDoYouWant? -->
        <ng-container *ngSwitchCase="wizardStepsEnum.Asset_RequestType">
          <form [formGroup]="firstQuestionFormGroup" class="wizard-item">
            <div class="row">
              <div class="col-12 wizard-question">
                {{
                  "requests.wizard.questions.WhatTypeOfRequestDoYouWant"
                    | translate
                }}
              </div>
            </div>
            <div class="row justify-content-center" *ngIf="DRIVING_ABROAD">
              <div
                class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 radio-container"
              >
                <input
                  class="radio-input"
                  type="radio"
                  kendoRadioButton
                  size="large"
                  id="drivingabroad"
                  name="answear"
                  [value]="DRIVING_ABROAD"
                  [(ngModel)]="firstQuestionFormGroup.value.answear"
                  (ngModelChange)="clearWizardForm()"
                  formControlName="answear"
                  required
                />
                <label HJSuppress class="radio-label" for="drivingabroad">
                  {{ "requests.wizard.answears.DrivingAbroadEmpowerment" | translate }}
                </label>
              </div>
            </div>
            <div class="row justify-content-center" *ngIf="DAMAGE_DELEGACY">
              <div
                class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 radio-container"
              >
                <input
                  class="radio-input"
                  type="radio"
                  kendoRadioButton
                  size="large"
                  id="damagedelegacy"
                  name="answear"
                  [value]="DAMAGE_DELEGACY"
                  [(ngModel)]="firstQuestionFormGroup.value.answear"
                  (ngModelChange)="clearWizardForm()"
                  formControlName="answear"
                  required
                />
                <label HJSuppress class="radio-label" for="damagedelegacy">
                  {{ "requests.wizard.answears.DamageDelegacy" | translate }}
                </label>
              </div>
            </div>

            <div class="row justify-content-center" *ngIf="VIGNETTE">
              <div
                class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 radio-container"
              >
                <input
                  class="radio-input"
                  type="radio"
                  kendoRadioButton
                  size="large"
                  id="vignette"
                  name="answear"
                  [value]="VIGNETTE"
                  [(ngModel)]="firstQuestionFormGroup.value.answear"
                  (ngModelChange)="clearWizardForm()"
                  formControlName="answear"
                  required
                />
                <label HJSuppress class="radio-label" for="vignette">
                  {{ "requests.wizard.answears.Vignette" | translate }}
                </label>
              </div>
            </div>

            <div class="row justify-content-center" *ngIf="OTHER">
              <div
                class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 radio-container textarea-option"
              >
                <input
                  class="radio-input"
                  type="radio"
                  kendoRadioButton
                  size="large"
                  id="other"
                  name="answear"
                  [value]="OTHER"
                  [(ngModel)]="firstQuestionFormGroup.value.answear"
                  (ngModelChange)="clearWizardForm()"
                  formControlName="answear"
                  required
                />
                <label HJSuppress class="radio-label" for="other">
                  {{ "requests.wizard.answears.Other" | translate }}
                  <kendo-textarea class="textarea-input"
                    placeholder="{{'requests.wizard.answears.mentionReason' | translate}}"
                    name="other-textarea"
                    resizable="none"
                    formControlName="otherObservations"
                    [(ngModel)]="firstQuestionFormGroup.value.otherObservations"
                    [required]="firstQuestionFormGroup.value.answear === OTHER"
                  >
                  </kendo-textarea>
                </label>
              </div>
            </div>

          <!-- document uploader -->
            <div class="row justify-content-center align-items-center mt-3">
              <asset-document-request-uploader 
                *ngIf="currentWizardStep !== wizardStepsEnum.Asset_RequestSent"
                [assetDocumentRequest]="requestXDocuments"
                [deleteFileHandler]="_filesHandler.deleteFileHandler"
                [uploadFilesHandler]="_filesHandler.uploadFilesHandler"
                class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
              </asset-document-request-uploader>
            </div>
          <!-- document uploader -->

            <div class="row">
              <div class="col-12 action">
                <div class="d-flex justify-content-center mt-5">
                  <button
                    class="btn primary-btn"
                    [disabled]="firstQuestionFormGroup.invalid"
                    (click)="
                        nextStepHandler(
                        wizardStepsEnum.Asset_RequestType
                        )
                    ">
                    {{ "requests.wizard.continueBtn" | translate }}
                  </button>
                </div>
              </div>
            </div>
            <!-- {{firstQuestionFormGroup.value | json}} // debug wizard -->
          </form>
        </ng-container>
        <!-- Step 0 - WhatTypeOfRequestDoYouWant? -->

        <!-- Step 1 - WhoWillBeTheDelegate? -->
        <ng-container *ngSwitchCase="wizardStepsEnum.Asset_Delegate">
          <form [formGroup]="secondQuestionFormGroup" class="wizard-item">
            <ng-container *ngIf="!addDelegateFormVisible">
              <div class="row">
                <div class="col-12 wizard-question">
                  {{
                    "requests.wizard.questions.WhoWillBeTheDelegate" | translate
                  }}
                </div>
              </div>
              <div class="row justify-content-center">
                <div *ngFor="let delegate of delegates; let indexDelegate = index"
                  class="d-flex flex-column col-md-6 col-lg-4 col-xl-4 col-xxxl-3"
                >
                  <div class="radio-container px-3"
                    [ngClass]="{
                      'item-selected':
                        secondQuestionFormGroup.value !== null &&
                        secondQuestionFormGroup.value.answear ===
                          delegate.delegateId,
                    }"
                    (mouseover)="delegate.displayEditIcons = true"
                    (mouseout)="delegate.displayEditIcons = false"
                  >
                    <input
                      class="radio-input delegate-radio-input"
                      type="radio"
                      kendoRadioButton
                      size="large"
                      [value]="delegate.delegateId"
                      formControlName="answear"
                      required
                      id="radio-{{ indexDelegate }}"
                    />
                    <label HJSuppress class="radio-label m-0" for="radio-{{ indexDelegate }}">
                      <span class="fw-bold me-2">
                        {{ delegate.firstName }}
                      </span>
                      {{ " " + delegate.lastName }}
                    </label>
                  </div>

                  <div class="options-div d-flex justify-content-end gap-2"
                    [ngClass]="[
                      delegate.displayEditIcons === false ||
                      delegate.isReadOnly === true
                        ? 'invisible'
                        : '',
                    ]"
                    (mouseover)="delegate.displayEditIcons = true"
                    (mouseout)="delegate.displayEditIcons = false"
                  >
                    <button class="btn edit-btn action-btn" (click)="editDelegateHandler(delegate)">
                      <i class="app-icon icon icon-edit icon-xl"></i>
                    </button>
                    <button *ngIf="delegate.hasRequests" class="btn delete-btn pe-auto disabled-action-btn"
                      disabled
                      [ngbTooltip]="'requests.wizard.delegateDeleteDisabled' | translate"
                      placement="top"
                    >
                      <i class="app-icon icon icon-delete icon-xl"></i>
                    </button>
                    <button *ngIf="!delegate.hasRequests" class="btn delete-btn action-btn"
                      (click)="removeDelegateHandler(delegate)"
                    >
                      <i class="app-icon icon icon-delete icon-xl"></i>
                    </button>
                  </div>  
                </div>

                <div class="col-md-6 col-lg-4 col-xl-4 col-xxxl-3 d-flex align-items-start fw-semibold">
                  <button
                    class="btn add-delegate-btn mx-3 flex-grow-1"
                    (click)="addDelegate()"
                  >
                    <span>{{ "requests.wizard.addDelegate" | translate }}</span>
                    <i class="app-icon icon icon-add ms-2"></i>
                  </button>
                </div>
              </div>
              
              <div class="row">
                <div class="col-12 action">
                  <div class="d-flex justify-content-center mt-5">
                    <button
                      class="btn primary-btn"
                      [disabled]="secondQuestionFormGroup.value.answear === null"
                      (click)="
                        nextStepHandler(
                          wizardStepsEnum.Asset_Delegate
                        )
                      "
                    >
                      {{ "requests.wizard.continueBtn" | translate }}
                    </button>
                  </div>
                </div>
              </div>
              <!-- {{secondQuestionFormGroup.value | json}} // debug wizard-->
            </ng-container>

            <app-add-delegate
              *ngIf="addDelegateFormVisible"
              [newDelegate]="newDelegate"
              (delegateSaved)="delegateSavedHandler($event)"
            ></app-add-delegate>
          </form>
        </ng-container>
        <!-- Step 1 - WhoWillBeTheDelegate? -->

        <!-- Step 2 - WhichCountriesYouTransitAndInWhatPeriod? -->
        <ng-container *ngSwitchCase="wizardStepsEnum.Asset_CountriesTransit">
          <div class="row">
            <div class="col-12 wizard-question">
              {{
                "requests.wizard.questions.WhichCountriesYouTransitAndInWhatPeriod"
                  | translate
              }}
            </div>
          </div>

          <div class="row justify-content-center" *ngIf="countries">
            <div class="col-lg-10 col-xxl-8 col-xxxl-6">
              <kendo-multiselect HJSuppress
                class="custom-kendo-control-xl"
                fillMode="flat"
                [rounded]="roundedLarge"
                [size]="sizeLarge"   
                name="transitedCountries"
                #transitedCountries="ngModel"
                [data]="filteredCountries"
                [textField]="'dictionaryCountryName'"
                [valueField]="'dictionaryCountryId'"
                [filterable]="true"
                (filterChange)="handleFilter($event)"
                placeholder="{{
                  'requests.wizard.addDelegateForm.placeholder.countries'
                    | translate
                }}"
                [clearButton]="false"
                [(ngModel)]="selectedCountries"
                (ngModelChange)="selectCountryHandler($event)"
                [popupSettings]="{popupClass : 'data-hj-suppress'}"
              >
                <ng-template kendoPrefixTemplate>
                  <i class="app-icon icon icon-search icon-xxl"></i>
                </ng-template>

                <ng-template kendoAutoCompleteItemTemplate let-dataItem>
                  <div *ngIf="dataItem" class="autocomplete-template-container">
                    <div
                      class="autocomplete-main-label d-flex align-items-center gap-3"
                    >
                      <img
                        src="assets/img/country-flags/{{dataItem.iocCode}}.svg"
                        alt="{{ dataItem.iocCode }}"
                        class="autocomplete-flag-ico rounded-circle"
                      />
                      <span>{{ dataItem.dictionaryCountryName }}</span>
                    </div>
                  </div>
                </ng-template>
              </kendo-multiselect>

              <div class="selected-countries-container d-flex flex-column gap-4 my-4">
                <div class="country-card d-flex align-items-center gap-4"
                  *ngFor="
                    let selectedCountry of selectedCountries;
                    let indexCountry = index
                  "
                >
                  <div class="flex-grow-1 d-flex align-items-center">
                    <img
                      [src]="
                        '/assets/img/country-flags/' +
                        selectedCountry.iocCode +
                        '.svg'
                      "
                      class="flag-ico rounded-circle"
                    />
                    <span HJSuppress class="flex-grow-1 flag-label text-end">
                      {{ selectedCountry.dictionaryCountryName }}
                    </span>
                  </div>
                  <button
                    type="button"
                    class="btn-close"
                    (click)="removeSelectedCountry(selectedCountry.dictionaryCountryId)"
                  >
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3">
              <label class="label-input required">
                {{ "requests.wizard.fromDate" | translate }}
              </label>
              <div class="date-input-container">
                <kendo-datepicker HJSuppress
                  class="custom-kendo-control-xl"
                  [fillMode]="fillModeOutline"
                  [rounded]="roundedLarge"
                  #fromDateForm
                  name="fromDate"
                  [(ngModel)]="fromDate"
                  (click)="!fromDateForm.isOpen ? fromDateForm.toggle() : null"
                  (ngModelChange)="checkTransitFromDateValidity($event)"
                  [popupSettings]="{popupClass : 'data-hj-suppress'}"
                  [disabledDates]="disableTransitFromDates"
                >
                  <kendo-datepicker-messages
                    today="{{ 'calendar.today' | translate }}"
                    toggle="{{ 'calendar.toggle' | translate }}"
                  >
                  </kendo-datepicker-messages>
                </kendo-datepicker>
              </div>
            </div>
            <div class="col-md-6 col-lg-5 col-xxl-4 col-xxxl-3">
              <label class="label-input required">
                {{ "requests.wizard.toDate" | translate }}
              </label>
              <i class="app-icon icon icon-info-circle-fill info-tooltip-trigger ms-1 text-secondary"
                [ngbTooltip]="drivingAbroadToDateTooltip" >
              </i>
              <div class="date-input-container">
                <kendo-datepicker HJSuppress
                  class="custom-kendo-control-xl"
                  [fillMode]="fillModeOutline"
                  [rounded]="roundedLarge"
                  #toDateForm
                  name="toDate"
                  [(ngModel)]="toDate"
                  (click)="!toDateForm.isOpen ? toDateForm.toggle() : null"
                  (ngModelChange)="checkTransitContractInsuranceValidity($event)"
                  [disabled]="fromDate === null"
                  [disabledDates]="disableTransitToDates"
                  [popupSettings]="{popupClass : 'data-hj-suppress'}"
                >
                  <kendo-datepicker-messages
                    today="{{ 'calendar.today' | translate }}"
                    toggle="{{ 'calendar.toggle' | translate }}"
                  >
                  </kendo-datepicker-messages>
                </kendo-datepicker>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-lg-10 col-xxl-8 col-xxxl-6">
              <div *ngIf="transitErrorMessageTranslateKey">
                <ng-container *ngTemplateOutlet="errorMessageTemplate; context: { $implicit: transitErrorMessageTranslateKey}"></ng-container>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 action">
              <div class="d-flex justify-content-center mt-5">
                <button
                  class="btn primary-btn"
                  [disabled]="checkTransitedCountriesForm()"
                  (click)="
                    nextStepHandler(wizardStepsEnum.Asset_CountriesTransit)
                  "
                >
                    {{ "requests.wizard.continueBtn" | translate }}
                </button>
              </div>
            </div>
          </div>
          <!-- {{selectedCountries | json}}// debug wizard -->
        </ng-container>
        <!-- Step 2 - WhichCountriesYouTransitAndInWhatPeriod? -->

        <!-- Step 3 - DoYouNeedAnyAdditionalInsurances? -->
        <ng-container *ngSwitchCase="wizardStepsEnum.Asset_AdditionalInsurances">
          <form [formGroup]="thirdQuestionFormGroup" class="wizard-item">
            <div class="row">
              <div class="col-12 wizard-question">
                {{
                  "requests.wizard.questions.DoYouNeedAnyAdditionalInsurances"
                    | translate
                }}
                <div class="skip-step">
                  {{ "requests.wizard.skip1" | translate }}
                  <span
                    (click)="
                      nextStepHandler(
                        wizardStepsEnum.Asset_AdditionalInsurances,
                        true
                      )
                    "
                  >
                    {{ "requests.wizard.skip2" | translate }}
                  </span>
                  {{ "requests.wizard.skip3" | translate }}
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div
                class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 checkbox-container"
                [ngClass]="{
                  'item-selected':
                    thirdQuestionFormGroup.value !== null &&
                    thirdQuestionFormGroup.value.answear1
                }"
              >
                <label HJSuppress for="greenCardInsurance" class="checkbox-label user-select-none cursor-pointer p-3 d-flex align-items-center gap-3">
                  <input
                    type="checkbox"
                    kendoCheckBox
                    size="large"
                    rounded="large"
                    formControlName="answear1"
                    id="greenCardInsurance"
                  />
                  <span>{{ "requests.wizard.answears.GreenCardInsurance" | translate }}</span>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12 action">
                <div class="d-flex justify-content-center mt-5">
                  <button
                    class="btn primary-btn"
                    (click)="
                      nextStepHandler(
                        wizardStepsEnum.Asset_AdditionalInsurances
                      )
                    "
                  >
                    {{ "requests.wizard.continueBtn" | translate }}
                  </button>
                </div>
              </div>
            </div>
            <!-- {{thirdQuestionFormGroup.value | json}}// debug wizard -->
          </form>
        </ng-container>
        <!-- Step 3 - DoYouNeedAnyAdditionalInsurances? -->

        <!-- Step 3 - WhenDidTheEventHappen?(_damageDelegacy) -->
        <ng-container *ngSwitchCase="wizardStepsEnum.Asset_DescribeEvent">
          <div class="row">
            <div class="col-12 wizard-question">
              {{
                "requests.wizard.questions.WhenDidTheEventHappened" | translate
              }}
            </div>
          </div>
          <div class="row justify-content-center mb-3">
            <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
              <label class="label-input required">
                {{ "requests.wizard.eventDate" | translate }}
              </label>
              <i class="app-icon icon icon-info-circle-fill info-tooltip-trigger ms-1 text-secondary"
                [ngbTooltip]="damageDelegacyEventDateTooltip" 
              ></i>
              <div class="date-input-container">
                <kendo-datepicker HJSuppress
                  class="custom-kendo-control-xl"
                  [fillMode]="fillModeOutline"
                  [rounded]="roundedLarge"
                  #eventDateForm
                  name="eventDate"
                  [(ngModel)]="eventDate"
                  (click)="(!eventDateForm.isOpen ? eventDateForm.toggle() : null)"
                  (ngModelChange)="checkEventDateValidity($event)"
                  [min]="damageDelegacyMinDate"
                  [max]="damageDelegacyMaxDate"
                  [popupSettings]="{popupClass : 'data-hj-suppress'}"
                >
                  <kendo-datepicker-messages
                    today="{{ 'calendar.today' | translate }}"
                    toggle="{{ 'calendar.toggle' | translate }}"
                  >
                  </kendo-datepicker-messages>
                </kendo-datepicker>
              </div>
            </div>
          </div>
          <div class="row justify-content-center mb-3">
            <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
              <label class="label-input required">
                {{ "requests.wizard.nameOfInsurer" | translate }}
              </label>
              <input class="custom-kendo-control-xl"
                kendoTextBox
                rounded="large"
                name="nameOfInsurer"
                #nameOfInsurer="ngModel"
                type="text"
                placeholder="{{
                  'requests.wizard.addDelegateForm.placeholder.insurerName'
                    | translate
                }}"
                [(ngModel)]="insurerName"
                required
              />
            </div>
          </div>
          <div class="row justify-content-center" *ngIf="technicalServicesDataSource.length > 0">
            <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
              <label class="label-input required">
                {{ "requests.wizard.repairService" | translate }}
              </label>
              <div class="input-dropdown-container">
                <kendo-combobox
                  HJSuppress
                  class="custom-kendo-control-xl"
                  [fillMode]="fillModeOutline"
                  [rounded]="roundedLarge"
                  [size]="sizeLarge"
                  name="technicalService"
                  [placeholder]="'requests.wizard.placeholder.selectRepaiService' | translate"
                  [clearButton]="false"
                  [data]="filteredTechnicalServices"
                  textField="name"
                  valueField="externalEntityId"
                  [(ngModel)]="selectedTechnicalService"
                  [popupSettings]="{popupClass : 'data-hj-suppress'}"
                  [required]="technicalServicesDataSource.length > 0"
                  [filterable]="true"
                  (filterChange)="handleFilterTechnicalServices($event)"
                  #technicalExternalEntityId
                  (click)="
                    !technicalExternalEntityId.isOpen
                      ? technicalExternalEntityId.toggle()
                      : null
                  "
                >
                </kendo-combobox>
              </div>
            </div>
          </div>
          <div class="row justify-content-center mb-3">
            <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
              <label class="label-input">
                {{ "requests.wizard.observations" | translate }}
              </label>
              <kendo-textarea class="custom-kendo-control-xl"
                rounded="large"
                placeholder="{{ 'requests.wizard.observationPlaceholder' | translate }}"
                name="event-textarea"
                [rows]="8"
                resizable="vertical"
                [(ngModel)]="observations"
              >
              </kendo-textarea>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 required-fields-label"
              [innerHTML] ="'common.requiredFields' | translate">
            </div>
          </div>
        <div class="row justify-content-center">
          <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
            <div *ngIf="eventDateErrorMessageTranslateKey">
              <ng-container *ngTemplateOutlet="errorMessageTemplate; context: { $implicit: eventDateErrorMessageTranslateKey}"></ng-container>
            </div>
          </div>
        </div>
          <div class="row">
            <div class="col-12 action">
              <div class="d-flex justify-content-center mt-5">
                <button
                  class="btn primary-btn"
                  [disabled]="checkDamageEventDetails()"
                  (click)="nextStepHandler(wizardStepsEnum.Asset_DescribeEvent)"
                >
                    {{ "requests.wizard.continueBtn" | translate }}
                </button>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- Step 3 - WhenDidTheEventHappen?(_damageDelegacy) -->



        <!-- Step 7 - Vignette -->
        <ng-container *ngSwitchCase="wizardStepsEnum.Vignette_Details">
          <div class="row">
            <div class="col-12 wizard-question">
              {{
                "requests.wizard.questions.ValabilityStartingDate" | translate
              }}
            </div>
          </div>
          <div class="row justify-content-center mb-3">
            <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
              <div class="date-input-container">
                <label class="label-input required">
                  {{ "requests.wizard.fromDate" | translate }}
                </label>
                <kendo-datepicker HJSuppress
                  class="custom-kendo-control-xl"
                  [fillMode]="fillModeOutline"
                  [rounded]="roundedLarge"
                  #eventDateForm
                  name="eventDate"
                  [(ngModel)]="eventDate"
                  (click)="(!eventDateForm.isOpen ? eventDateForm.toggle() : null)"
                  [disabledDates]="disabledPastVignetteMinDate"
                  [popupSettings]="{popupClass : 'data-hj-suppress'}"
                >
                  <kendo-datepicker-messages
                    today="{{ 'calendar.today' | translate }}"
                    toggle="{{ 'calendar.toggle' | translate }}"
                  >
                  </kendo-datepicker-messages>
                </kendo-datepicker>
              </div>
            </div>
          </div>

          <div class="row justify-content-center mb-3">
            <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
              <label class="label-input">
                {{ "requests.wizard.observations" | translate }}
              </label>
              <kendo-textarea class="custom-kendo-control-xl"
                rounded="large"
                [placeholder]="'requests.wizard.observations' | translate" 
                name="event-textarea"
                [rows]="8"
                resizable="vertical"
                [(ngModel)]="observations"
              >
              </kendo-textarea>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 required-fields-label"
                [innerHTML] ="'common.requiredFields' | translate">
            </div>
          </div>
          <div class="row">
            <div class="col-12 action">
              <div class="d-flex justify-content-center mt-5">
                <button
                  class="btn primary-btn"
                  [disabled]="checkVignetteDetails()"
                  (click)="nextStepHandler(wizardStepsEnum.Vignette_Details)"
                >
                    {{ "requests.wizard.continueBtn" | translate }}
                </button>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- Step 7 - Vignette -->

        <!-- Step 8 - Request Preview -->
        <ng-container *ngSwitchCase="wizardStepsEnum.Request_Preview">
            <div class="d-flex justify-content-center fw-bold fs-4 l-preview-title">
                {{ "requests.wizard.preview.title" | translate }}
            </div>
            <div class="d-flex flex-column justify-content-start pb-3 mb-4">
                <div class="l-item-section">
                    <span class="l-section-title fw-semibold">{{"requests.wizard.preview.contractAndAsset" | translate}}</span>
                    <div HJSuppress class="section-content">
                        <ul>
                            <li>{{ documentRequestHeader.contractName }}</li>
                            <li>{{ documentRequestHeader.assetName }}</li>
                        </ul>
                    </div>
                </div>
                <div class="l-item-section">
                    <span class="l-section-title fw-semibold">{{"requests.wizard.preview.requestType" | translate}}
                    </span>
                    <div HJSuppress class="section-content">
                        <ul>
                            <li>{{ selectedRequestType.requestTypeName }}</li>
                        </ul>
                        <button class="btn edit-btn custom-edit-btn ms-auto" 
                            (click)="editWizardStepHandler(wizardStepsEnum.Asset_RequestType)">
                            <i class="app-icon icon icon-edit icon-xl"></i>
                        </button>
                    </div>
                </div>
                <div class="l-item-section" 
                    *ngIf="selectedDelegate && (selectedRequestType === DRIVING_ABROAD || selectedRequestType === DAMAGE_DELEGACY)">
                    <span class="l-section-title fw-semibold">{{'requests.wizard.preview.selectedDelegate' | translate}}</span>
                    <div HJSuppress class="section-content">
                        <ul>
                            <li>
                                {{ selectedDelegate?.firstName + " " + selectedDelegate?.lastName }}
                            </li>
                        </ul>
                        <button class="btn edit-btn custom-edit-btn ms-auto" 
                            (click)="editWizardStepHandler(wizardStepsEnum.Asset_Delegate)">
                            <i class="app-icon icon icon-edit icon-xl"></i>
                        </button>
                  </div>
                </div>
                <div *ngIf="selectedRequestType === DRIVING_ABROAD">
                    <div class="l-item-section" 
                        *ngIf="thirdQuestionFormGroup.value.answear1">
                        <span class="l-section-title fw-semibold">{{'requests.wizard.preview.additionaInsurance' | translate}}</span>
                        <div HJSuppress class="section-content">
                            <ul>
                                <li *ngIf="thirdQuestionFormGroup.value.answear1">{{ "requests.wizard.answears.GreenCardInsurance" | translate }}</li>
                            </ul>
                            <button class="btn edit-btn custom-edit-btn ms-auto" 
                                (click)="editWizardStepHandler(wizardStepsEnum.Asset_AdditionalInsurances)">
                                <i class="app-icon icon icon-edit icon-xl"></i>
                            </button>
                        </div>
                    </div>
                    <div class="l-item-section" >
                        <span class="l-section-title fw-semibold">
                            {{ "requests.wizard.preview.transitCountries" | translate }}
                        </span>
                        <div HJSuppress class="section-content">
                            <ul>
                                <li *ngFor="let country of selectedCountries">
                                    {{ country.dictionaryCountryName }}
                                </li>
                                <li>
                                    <span>{{"requests.wizard.preview.fromDate" | translate }} 
                                        <span class="fw-semibold">{{fromDate | localizedDate }}</span>
                                    </span>
                                    -
                                    <span>{{"requests.wizard.preview.toDate" | translate }} 
                                        <span class="fw-semibold">{{toDate | localizedDate }}</span>
                                    </span>
                                </li>
                            </ul>              
                            <button class="btn edit-btn custom-edit-btn ms-auto" 
                                (click)="editWizardStepHandler(wizardStepsEnum.Asset_CountriesTransit)">
                                <i class="app-icon icon icon-edit icon-xl"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="l-item-section" *ngIf="selectedRequestType===DAMAGE_DELEGACY">
                    <span class="l-section-title fw-semibold">
                        {{ "requests.wizard.preview.eventDelegacy" | translate }}
                    </span>
                    <div HJSuppress class="section-content">
                        <ul>
                            <li>
                                <span>{{"requests.wizard.preview.date" | translate }} 
                                    <span class="fw-semibold">{{eventDate | localizedDate }}</span>
                                </span>
                            </li>
                            <li>
                                <span>{{"requests.wizard.preview.delegatedInsurer" | translate }} 
                                    <span class="fw-semibold">{{insurerName}}</span>
                                </span>
                            </li>
                            <li *ngIf="observations">
                                <span>{{"requests.wizard.preview.observations" | translate }} 
                                    <span class="fw-semibold">{{observations}}</span>
                                </span>
                            </li>
                        </ul>
                        <button class="btn edit-btn custom-edit-btn ms-auto" 
                            (click)="editWizardStepHandler(wizardStepsEnum.Asset_DescribeEvent)">
                            <i class="app-icon icon icon-edit icon-xl"></i>
                        </button>
                    </div>
                </div>
                <div class="l-item-section" *ngIf="selectedRequestType===VIGNETTE">
                    <span class="l-section-title fw-semibold">
                        {{ "requests.wizard.preview.Vignette" | translate }}
                    </span>
                    <div HJSuppress class="section-content">
                        <ul>
                            <li >
                                <span>{{"requests.wizard.preview.fromDate" | translate }} 
                                    <span class="fw-semibold">{{eventDate | localizedDate }}</span>
                                </span>
                            </li>
                            <li *ngIf="observations">
                                <span>{{"requests.wizard.preview.observations" | translate }} 
                                    <span class="fw-semibold">{{observations}}</span>
                                </span>
                            </li>
                        </ul>
                        <button class="btn edit-btn custom-edit-btn ms-auto" 
                            (click)="editWizardStepHandler(wizardStepsEnum.Vignette_Details)">
                            <i class="app-icon icon icon-edit icon-xl"></i>
                        </button>
                    </div>
                </div>
                <div class="l-item-section" *ngIf="selectedRequestType === OTHER">
                    <span class="l-section-title fw-semibold">
                        {{ "requests.wizard.preview.otherDetails" | translate }}
                    </span>
                    <div HJSuppress class="section-content">
                        <ul>
                            <li >
                                {{firstQuestionFormGroup.value.otherObservations }}
                            </li>
                        </ul>
                        <button class="btn edit-btn custom-edit-btn ms-auto" 
                            (click)="editWizardStepHandler(wizardStepsEnum.Asset_RequestType)">
                            <i class="app-icon icon icon-edit icon-xl"></i>
                        </button>
                    </div>
                </div>
                <div *ngIf="selectedRequestType.description" class="d-flex justify-content-center">
                    <div class="col-8">
                        <div class=" d-flex justify-content-center">
                            <i class="app-icon icon icon-warning-triangle-fill icon-xl me-2"></i>
                            <span [innerHtml]="selectedRequestType.description"></span>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedRequestType === DRIVING_ABROAD">
                  <div class="d-flex justify-content-center casco-notice-container">
                      <i class="app-icon icon icon-warning-triangle-fill icon-xl me-2"></i>
                      <span [innerHTML]="'requests.wizard.preview.insuranceCascoCheckCountriesNotice' | translate"></span>
                  </div>
                </div>
            </div>

            <label for="hasConfirmedInfoVerification" class="user-select-none cursor-pointer my-3 p-2 d-flex align-items-center gap-2">
              <input
                type="checkbox"
                kendoCheckBox
                size="large"
                rounded="large"
                name="hasConfirmedInfoVerification"
                id="hasConfirmedInfoVerification"
                [(ngModel)]="hasConfirmedInfoVerification"
                required
              />
              <span>{{ "requests.wizard.preview.hasConfirmedInfoVerificationLabel" | translate }}</span>
            </label>

            <div class="d-flex justify-content-center">
                <button class="btn primary-btn" 
                  [disabled]="!hasConfirmedInfoVerification"
                  (click)="nextStepHandler(wizardStepsEnum.Request_Preview)">
                  {{ "contractModifications.wizard.sendRequestBtn" | translate }}
                </button>
            </div>
        </ng-container>
        <!-- Request preview -->

        <!-- Request sent -->
        <ng-container *ngSwitchCase="wizardStepsEnum.Asset_RequestSent">
          <div class="request-sent-container wizard-item">
            <span class="request-sent-title">{{'requests.wizard.requestSentTitle' | translate}}</span>
            <span class="request-sent-subtitle">
                <span>{{'requests.wizard.requestSentSubtitle1' | translate}}</span>
                <span class="text-primary fw-bold cursor-pointer" (click)="redirectRequestsList()">
                  {{'requests.wizard.requestSentSubtitle2' | translate}}
                </span>
                <span>{{'requests.wizard.requestSentSubtitle3.assetDocuments' | translate}}</span>
            </span>
            <request-sent-placeholder class="mt-5"></request-sent-placeholder>
          </div>
        </ng-container>
        <!-- Request sent -->
      </form>
    </div>
  </div>
</div>

<ng-template #drivingAbroadToDateTooltip>
  {{ "requests.wizard.toDateTooltip" | translate }}
</ng-template>

<ng-template #damageDelegacyEventDateTooltip>
  {{ "requests.wizard.eventDateTooltip" | translate }}
</ng-template>

<ng-template #errorMessageTemplate let-errorMessageTranslationKey>
  <div class="alert alert-danger custom-alert" role="alert">
    <div class="alert-body d-flex align-items-center">
      <i class="app-icon icon icon-warning-triangle-fill icon-xl"></i>
      <span [innerHTML]="errorMessageTranslationKey | translate"></span>
    </div>
  </div>
</ng-template>